export default __webpack_public_path__ + "static/media/Netflix-Logo-PNG3.a3092e10.png";